import React from 'react'
import { css } from 'aphrodite'
import { Row, Col } from 'reactstrap'

/* eslint-disable */
import { inject, observer } from 'mobx-react'
/* eslint-enable */

import style from './style'

import ScrollArea from '../partials/ScrollArea'

import TicketMessage from './partials/TicketMessage'
import ReplyForm from './partials/ReplyForm'
import SupportHeader from './partials/SupportHeader'

import access from '../../utils/access'

const THEME_LIST = [
  { name: 'Regular', label: 'Regular' },
  { name: 'ColorBlind', label: 'ColorBlind' }
]

@inject('Auth', 'User', 'Ticket', 'Community', 'Config')
@observer
export class Support extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      editor: {
        message: ''
      },
      hoverId: null
    }

    this.scrollRef = null
  }

  _findTickets () {
    setTimeout(() => {
      if (this.props.Auth.token.pending || this.props.User.me.pending) {
        return this._findTickets()
      }

      Promise.all([
        this.props.Ticket.getTicket(this.props.match.params.id),
        this.props.Ticket.getResponses(this.props.match.params.id)
      ]).then(data => {
        Promise.all([
          ...(!this.props.User.all.slice().find(u => u.id === data[0].userId)
            ? [this.props.User.getUser(data[0].userId)]
            : []),
          ...(data[0].comId &&
          !this.props.Community.all.slice().find(c => c.id === data[0].comId)
            ? [this.props.Community.getCommunity(data[0].comId)]
            : [])
        ])
      })
    }, 500)
  }

  componentWillMount () {
    this._findTickets()
  }

  componentDidMount () {
    this.scrollRef.scrollToBottom()
  }

  componentDidUpdate (prevProps, prevState) {
    if (prevState.hoverId !== this.state.hoverId) {
      return
    }

    this.scrollRef.scrollToBottom()
  }

  componentWillReceiveProps (newProps) {
    if (this.props.match.params.id !== newProps.match.params.id) {
      this._findTickets()
    }
  }

  onFormSubmit (e) {
    e.preventDefault()
    const message = this.state.editor.message

    if (message.length < 1) {
      return
    }

    this.setState(
      {
        ...this.state,
        editor: { message: '' }
      },
      () => {
        this.props.Ticket.postResponse(this.props.match.params.id, message)
      }
    )
  }

  onInputChange (e) {
    this.setState({
      ...this.state,
      editor: {
        ...this.state.editor,
        message: e.target.value
      }
    })
  }

  onCategoryChange (e) {
    const ticket = this.props.Ticket.tickets.all
      .slice()
      .find(t => t.id === this.props.match.params.id)

    if (ticket.category === +e.target.value) {
      return
    }

    this.props.Ticket.patchTicket(
      this.props.match.params.id,
      'category',
      +e.target.value
    )
  }

  onStatusChange (e) {
    const ticket = this.props.Ticket.tickets.all
      .slice()
      .find(t => t.id === this.props.match.params.id)

    if (ticket.status === +e.target.value) {
      return
    }

    this.props.Ticket.patchTicket(
      this.props.match.params.id,
      'status',
      +e.target.value
    )
  }

  onPriorityChange (e) {
    const ticket = this.props.Ticket.tickets.all
      .slice()
      .find(t => t.id === this.props.match.params.id)

    if (ticket.priority === +e.target.value) {
      return
    }

    this.props.Ticket.patchTicket(
      this.props.match.params.id,
      'priority',
      +e.target.value
    )
  }

  onMessageHover (id) {
    this.setState({
      ...this.state,
      hoverId: id
    })
  }

  render () {
    const ticket = this.props.Ticket.tickets.all
      .slice()
      .find(t => t.id === this.props.match.params.id)
    const owner = this.props.User.all
      .slice()
      .find(u => ticket && u.id === ticket.userId)
    const community = this.props.Community.all
      .slice()
      .find(c => ticket && c.id === ticket.comId)

    const responses = [
      ...(ticket ? [ticket] : []),
      ...(ticket ? [...(this.props.Ticket.responses[ticket.id] || [])] : [])
    ]

    return [
      <Row key={0}>
        <SupportHeader
          ticket={ticket}
          owner={owner}
          community={community}
          onCategoryChange={this.onCategoryChange.bind(this)}
          onStatusChange={this.onStatusChange.bind(this)}
          onPriorityChange={this.onPriorityChange.bind(this)}
        />
      </Row>,
      <Row key={1} style={{ flex: 1 }}>
        <ScrollArea
          ref={e => (this.scrollRef = e)}
          style={{
            width: '100%',
            height: `100%`,
            paddingRight: `0`,
            paddingLeft: `0`,
            overflowX: `hidden`,
            border: `1px solid #f6f6f6`,
            borderTop: `none`,
            minHeight: `300px`
          }}
          // renderClassName={`d-flex align-items-end`}
        >
          {!ticket ? null : (
            <Col style={{ padding: `15px` }}>
              {responses
                .slice()
                .map((item, index) => (
                  <TicketMessage
                    theme={THEME_LIST[this.props.Config.theme]}
                    key={index}
                    {...item}
                    onHover={this.onMessageHover.bind(this)}
                    hoverState={item.id === this.state.hoverId}
                    isMod={access.modUser(this.props.User.me.permissions || {})}
                  />
                ))}
            </Col>
          )}
        </ScrollArea>
      </Row>,
      <Row
        key={2}
        className={css(
          ticket && ticket.status !== 1 ? style.tickets.reply : null
        )}
      >
        <Col>
          <ReplyForm
            onSubmit={this.onFormSubmit.bind(this)}
            onChange={this.onInputChange.bind(this)}
            ticket={ticket}
            editor={this.state.editor}
          />
        </Col>
      </Row>
    ]
  }
}

export default Support



// WEBPACK FOOTER //
// ./src/components/Support/SupportView.js